"use client";
import { createSplitProps } from "../../utils/create-split-props.js";
import { ark } from "../factory.js";
import { useProgressContext } from "./use-progress-context.js";
import { forwardRef } from "react";
import { mergeProps } from "@zag-js/react";
import { jsx } from "react/jsx-runtime";
//#region src/components/progress/progress-view.tsx
var splitViewProps = createSplitProps();
var ProgressView = forwardRef((props, ref) => {
	const [viewProps, localProps] = splitViewProps(props, ["state"]);
	const mergedProps = mergeProps(useProgressContext().getViewProps(viewProps), localProps);
	return /* @__PURE__ */ jsx(ark.span, {
		...mergedProps,
		ref
	});
});
ProgressView.displayName = "ProgressView";
//#endregion
export { ProgressView };
